var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "1zbhwhlrua"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.841605 0 0 0 0 0.841605 0 0 0 0 0.841605 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#1zbhwhlrua)",
    transform: "translate(-842 -699)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    transform: "translate(842 699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 40L16 32 8 40 8 26 24 26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0-1.24-.714-2.304-1.746-2.835.75-.886 1.003-2.142.528-3.288-.475-1.146-1.541-1.856-2.698-1.951.355-1.106.107-2.362-.77-3.24-.878-.877-2.134-1.124-3.24-.77-.095-1.157-.805-2.223-1.951-2.698-1.146-.475-2.402-.223-3.288.528C18.305.714 17.241 0 16 0c-1.24 0-2.304.714-2.835 1.746-.886-.75-2.142-1.003-3.288-.528-1.146.475-1.856 1.54-1.951 2.698-1.106-.354-2.362-.107-3.24.77-.877.878-1.125 2.134-.77 3.24-1.157.095-2.223.805-2.698 1.951-.475 1.146-.223 2.402.528 3.288C.714 13.695 0 14.759 0 16c0 1.24.714 2.304 1.746 2.835-.75.886-1.003 2.142-.528 3.288.475 1.146 1.541 1.856 2.698 1.951-.355 1.106-.107 2.362.77 3.24.878.877 2.134 1.125 3.24.77.095 1.157.805 2.223 1.951 2.698 1.146.475 2.402.223 3.288-.528C13.695 31.286 14.759 32 16 32c1.24 0 2.304-.714 2.835-1.746.886.75 2.142 1.003 3.288.528 1.146-.475 1.856-1.541 1.951-2.698 1.106.355 2.362.107 3.24-.77.877-.878 1.125-2.134.77-3.24 1.157-.095 2.223-.805 2.698-1.951.475-1.146.223-2.402-.528-3.288C31.286 18.305 32 17.241 32 16zm-16 8c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGrey);
export default __webpack_public_path__ + "static/media/badgeGrey.ad5172aad8b8dbd763bac2b8c327c1ea.svg";
export { ForwardRef as ReactComponent };